import { followProduct } from "../../../../../requests/following/product-follow-requests";
import {
	useFollowProductsContext,
	useFollowProductsDispatchContext,
} from "../../../../context/follow-products-context.jsx";
import { useInteractiveProductsSettings } from "../../../../context/interactive-product-context.jsx";
import { useAlertDispatch } from "../../../../context/alert-context.jsx";
import { ALERT_TYPE } from "../../../alert/Alert.jsx";
import { optionalTranslation } from "../../../../../translations/translation-utils.js";

export const useProductFollow = ({ productUid, followingRequestBody }) => {
	const productsFollow = useFollowProductsContext();
	const { addProductPendingRequest, finishProductPendingRequest } =
		useFollowProductsDispatchContext();

	const { translations, loginInfo, followUrl } =
		useInteractiveProductsSettings();

	const { addAlert } = useAlertDispatch();

	const following = productsFollow[productUid].following;
	const isRequesting = productsFollow[productUid].isPending;

	const buttonTitle = following
		? optionalTranslation(translations["button.product.unfollow.title"])
		: optionalTranslation(translations["button.product.follow.title"]);

	const performFollowRequest = async () => {
		addProductPendingRequest(productUid);

		try {
			if (following) {
				console.error(
					"[INTERACTIVE-PRODUCTS] Tried to follow a product that is already followed. This should be handled by the UI."
				);
				return;
			}

			await followProduct({
				followUrl,
				followingRequestBody,
			});

			addAlert({
				type: ALERT_TYPE.SUCCESS,
				message: optionalTranslation(translations["alert.product.followed"]),
			});

			finishProductPendingRequest(productUid, true);
		} catch (error) {
			console.error("[INTERACTIVE-PRODUCTS] Failed to follow product", error);
			finishProductPendingRequest(productUid);
		}
	};

	// Pokud uživatel není přihlášený, nebo mu běží request, nebo
	// pokud produkt sleduje, tak ho nemůže odsledovat !!
	const isButtonDisabled =
		isRequesting || !loginInfo?.isUserLoggedIn || following;

	return {
		performFollowRequest,
		following,
		isRequesting,
		isButtonDisabled,
		buttonTitle,
	};
};
